export default {
  "lead_availability": {
    "101": "This lead is no longer available",
    "102": "You have already rejected this lead",
    "103": "You have been offered this, but the availability guarantee expired on [[msg]]. This Lead is no longer available",
    "104": "To buy this lead you need to validate your email address first. If you have not received your validation email please " +
      "check your junk box or <a class='text-link text-link-reset' href='/'>visit the dashboard</a> to request another.",
    "105": "This lead is already accepted",
    "106": "Sorry, this lead has been removed following our review of the enquiry. Please accept our apologies for the email you " +
      "received prior to our manually reviewing this lead.",
    "107": "Sorry, you're too late! This lead has already been purchased a maximum of 3 times. Please accept our apologies for any inconvenience.",
    "108": "Sorry, you are not currently able to purchase leads. Please contact us to enable this facility.",
    "109": "Sorry, you are currently not able to purchase this lead as it would take you above your credit limit. Please " +
      "<a href='/account/invoices?settleAccount=true' class='text-link text-link-reset'>settle your account</a>  " +
      "balance or <a href='/help/contact' class='text-link text-link-reset'>contact</a> Account Management team to review your credit limit.",
    "110": "You have missing or expired <a class='text-link text-link-reset' href='/account/accreditations'>accreditations to update</a> before you can buy this lead. ",
  },
  "account": {
    "setup": "You can start buying leads by completing your <a class='text-link text-link-reset' href='/#todo'>To Do list.</a> It won’t take long.",
    "email": "Before you can buy leads, we need to verify your email address. Please check your Inbox and click the verification link."
  }
}
